/**
 * AudioControl
 * Embeds an audio player.
 * Performance: Memoized to prevent unnecessary re-renders
 */

import React, { memo } from 'react';
import type { ControlRendererProps } from '../ControlRenderer';

export const AudioControl = memo((props: ControlRendererProps) => {
  const { control } = props;
  const src = (control as any).src as string | undefined;
  if (!src) return <div className="af-audio-control af-audio-control--empty">No audio source</div>;

  return (
    <div className="af-audio-control" data-control-id={control.id}>
      {control.label && <p className="af-audio-control__label">{control.label}</p>}
      <audio src={src} controls style={{ width: '100%' }} />
    </div>
  );
});

AudioControl.displayName = 'AudioControl';

export default AudioControl;
